import React from "react";
import { InboxOutlined } from "@ant-design/icons";
import "./emptyState.scss";

// Shared "nothing here" block: used for empty tables/lists (via the antd
// ConfigProvider in App.js) and for pages that don't have content yet.
const EmptyState = ({
  icon = <InboxOutlined />,
  title,
  description,
  action,
  compact = false,
}) => (
  <div className={`empty-state${compact ? " empty-state--compact" : ""}`} role="status">
    <span className="empty-state__icon" aria-hidden="true">
      {icon}
    </span>
    {title && <p className="empty-state__title">{title}</p>}
    {description && <p className="empty-state__description">{description}</p>}
    {action && <div className="empty-state__action">{action}</div>}
  </div>
);

export default EmptyState;
